import React, { useState, useEffect } from 'react'
import { Select } from 'antd'

import Main from '../components/Main'
import LogList from '../components/LogList'   // Task009
import {
  CLONES_GET,
  requestToServer
} from '../lib/helper'

// Task009: la lista de logs, su paginación y las etiquetas de cada tipo pasaron a components/LogList.js
// (también la usa la ficha del clon). Acá queda solo el filtro por clon.

export default  () => {

  const [platformName, setPlatformName] = useState(undefined)   // undefined = todos los clones
  const [platformOptions, setPlatformOptions] = useState([])

  // opciones del filtro: los clones de la tabla clones, el mismo listado que carga Home.js
  useEffect(() => {
    requestToServer({}, CLONES_GET).then(r => {
      setPlatformOptions( r.clones.map(c => c.platformName).sort() )
    }).catch(()=>{})
  }, [])

  return(
    <Main
      pageHeader={{ title: 'Logs'  , back: true }}
    >

    <Select
      allowClear
      showSearch
      placeholder='Filtrar por clon'
      style={{width:'100%', marginBottom:'10px'}}
      value={platformName}
      onChange={setPlatformName}
      options={ platformOptions.map( p => ({value:p, label:p}) ) }
    />

    <LogList platformName={platformName} />

    </Main>
  )
}
